import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { dealerLotDuck } from '@/ducks';

const ELotPlaceholder = React.memo(({ children, userZipCode }) => {
    const [isELotShowing, setisELotShowing] = useState(true);
    const eLotListings = useSelector(dealerLotDuck.selectors.getListings);
    const fetchedDealerLot = useSelector(dealerLotDuck.selectors.fetchedDealerLot);

    useEffect(() => {
        // first time users without ATC_USER_ZIP
        if (!userZipCode) {
            setisELotShowing(false);
        }
        // after fetching eLot but returns no listings
        if (fetchedDealerLot && (!eLotListings || eLotListings.length === 0)) {
            setisELotShowing(false);
        }
    }, [eLotListings, fetchedDealerLot, userZipCode]);

    return isELotShowing && (
        <div
            className="elotPlaceholder"
            data-cmp="elotPlaceholder"
        >
            {children}
        </div>
    );
});

export default ELotPlaceholder;
